export default __webpack_public_path__ + "static/20-sitzer-5-462421d6ec1dde11bfe1586145ab38a4.jpg";